import { LanguageCode } from 'mytours-read-api-typescript'
import { Language } from 'mytours-read-common'
import SettingsService from './functions'
import { replaceLanguageCodeInPathname } from '../navigation/utils'
import { ionHistory } from '../navigation'
import { unloadAllSounds } from '../audio/soundController'

// Every app-language change must run these steps in this order: rewrite the
// locale segment of the current URL, release the old-language sounds, update
// the redux store, then persist the locale. Used by the settings page, the
// onboarding language gate (ReadyGate) and the header language button — add
// new steps here, not at the call sites. Lives in its own module (not
// settings/functions) because importing the navigation module from
// settings/functions would create an import cycle via logging/analytics.
export const changeAppLanguage = (
	supportedLanguages: LanguageCode[],
	language: Language,
	selectLanguage: (language: Language) => void,
): void => {
	const { search, hash, state } = ionHistory.location
	// Replace with a location object, not a bare pathname string: a string
	// resets search/hash/state, which would drop state.prevPagePath (the back
	// button target) and the ?m= modal stack when switching language from a
	// deep screen.
	ionHistory.replace({
		pathname: replaceLanguageCodeInPathname(supportedLanguages, language.code as LanguageCode),
		search,
		hash,
		state,
	})
	// Unload before the redux update: cached Howls hold the old language's audio
	// and would otherwise keep playing it on the still-mounted screen. Unloading
	// first also lets any synchronous onstop dispatches land before
	// appLanguageSelected resets the audioplayer state.
	unloadAllSounds()
	selectLanguage(language)
	SettingsService.appLanguage.setCurrentLocale(language.code)
}
